import React from 'react';
import {Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {useContractStatus} from 'presentation/hooks';
import {AlertInfo} from '../AlertInfo';
import {ProfileMenuEnum} from '../../../../tests/constants/ProfileMenuEnum';

const {suspendedContractAlert, cancelIn, cancelContract} = translations['pt-br'].commons;

const AlertSuspendedOrCanceled = () => {
	const {isContractSuspended, isValid, contractCancellationDateString} = useContractStatus();

	const renderContractSuspendedLabel = isContractSuspended ? suspendedContractAlert : null;
	const contractCanceledText = contractCancellationDateString ? cancelIn : cancelContract;
	const renderContractCanceledLabel = !isValid ? contractCanceledText : null;

	const renderContractDate = !isValid ? contractCancellationDateString : '';

	if (!isContractSuspended && isValid) {
		return null;
	}

	let dataTestId = '';

	if (!isValid) {
		dataTestId = ProfileMenuEnum.CANCELLED_CONTRACT;
	}
	if (isContractSuspended) {
		dataTestId = ProfileMenuEnum.SUSPENDED_CONTRACT;
	}

	return (
		<AlertInfo.Root
			severity="warning"
			sx={{padding: '0 0 0 8px', whiteSpace: 'normal', borderRadius: 0}}
			data-testid={dataTestId}>
			<AlertInfo.Description>
				<Typography variant="body2" fontSize={'1rem'}>
					{renderContractCanceledLabel || renderContractSuspendedLabel}
					<b>{renderContractDate}</b>
				</Typography>
			</AlertInfo.Description>
		</AlertInfo.Root>
	);
};

export {AlertSuspendedOrCanceled};
